import React, { Fragment } from 'react';
import T from 'prop-types';

import SwitchButtons from '../../../../../components/SwitchButtons';
import { ScreenshotButton } from '../../../../../components/Buttons/ScreenshotButton';
import ConsensusSourceText from '../../../../../components/ConsensusSourceText';

const defaultOptions = [
  { text: '#', value: 'values' },
  { text: '%', value: 'change' },
];

const ForecastsChartLayout = ({
  view,
  children,
  title,
  subtitle,
  disabled,
  screenshotUrl,
  isScreenshot,
  setView,
  showSourceText = true,
  options = defaultOptions,
  onScreenshot,
}) => (
  <Fragment>
    <div className="forecasts-main-content__header">
      <div className="forecasts-main-content__header-box">
        <div className="forecasts-main-content__header-head">{title}</div>
        {subtitle && <div className="forecasts-main-content__header-subhead">{subtitle}</div>}
      </div>
      {isScreenshot ? (
        <div className="copyrights">
          <div className="highcharts-watermark" />
          {showSourceText && <ConsensusSourceText className="data-source-text" />}
        </div>
      ) : (
        <div className="forecasts-main-content__header-buttons">
          <SwitchButtons
            options={options}
            active={view}
            disabled={disabled}
            containerClassName="btn-group-square"
            onChange={setView}
          />
          <ScreenshotButton
            href={screenshotUrl}
            target="_blank"
            disabled={disabled}
            onClick={onScreenshot}
          />
        </div>
      )}
    </div>
    <div className="forecasts-main-content__chart">{children}</div>
  </Fragment>
);

ForecastsChartLayout.propTypes = {
  view: T.string.isRequired,
  children: T.node.isRequired,
  title: T.string,
  subtitle: T.node,
  disabled: T.bool,
  screenshotUrl: T.string,
  isScreenshot: T.bool,
  setView: T.func,
  showSourceText: T.bool,
  options: T.arrayOf(
    T.shape({
      text: T.string,
      value: T.string,
    })
  ),
  onScreenshot: T.func,
};

export default ForecastsChartLayout;
